import AdvList from '@/components/adv/AdvList'
import Adv from '@/components/adv/Adv'
import FeuilleDeRoute from '@/components/adv/FeuilleDeRoute/FeuilleDeRoute'
import ContratDeReservation from '@/components/adv/FeuilleDeRoute/ContratDeReservation'
import Financement from '@/components/adv/FeuilleDeRoute/Financement'
import Notaire from '@/components/adv/FeuilleDeRoute/Notaire'
import Signature from '@/components/adv/FeuilleDeRoute/Signature'
import VenteActee from '@/components/adv/FeuilleDeRoute/VenteActee'
import Livraison from '@/components/adv/FeuilleDeRoute/Livraison'
import AppelDeFonds from '@/components/adv/FeuilleDeRoute/AppelDeFonds'
import ChoixEtTma from '@/components/adv/FeuilleDeRoute/ChoixEtTma'
import CommercialisationFacturation from '@/components/adv/Commercialisation/CommercialisationFacturation'
import SellerFacturation from '@/components/adv/Commercialisation/Facturation'
import Commercialisation from '@/components/adv/Commercialisation/Commercialisation'
import Documents from '@/components/adv/Documents'
import AdvRecap from '@/components/adv/Details/AdvRecap'
import AdvInfos from '@/components/adv/Details/AdvInfos'

export default [
  {
    path: '/advs',
    name: 'AdvList',
    component: AdvList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/advs/:id',
    name: 'AdvVue',
    component: Adv,
    props: true,
    meta: {
      parentName: 'AdvList',
      requiresAuth: true
    },
    children: [
      {
        path: 'recap',
        name: 'AdvRecap',
        component: AdvRecap,
        meta: {
          parentName: 'AdvVue',
          requiresAuth: true
        }
      },
      {
        path: 'feuille-de-route',
        name: 'FeuilleDeRoute',
        component: FeuilleDeRoute,
        meta: {
          parentName: 'AdvVue',
          requiresAuth: true
        },
        children: [
          {
            path: 'contrat-de-reservation',
            name: 'ContratDeReservation',
            component: ContratDeReservation,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'financement',
            name: 'Financement',
            component: Financement,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'notaire',
            name: 'Notaire',
            component: Notaire,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'signature',
            name: 'Signature',
            component: Signature,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'vente-actee',
            name: 'VenteActee',
            component: VenteActee,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'livraison',
            name: 'Livraison',
            component: Livraison,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'choix-et-tma',
            name: 'ChoixEtTma',
            component: ChoixEtTma,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'appel-de-fonds',
            name: 'AppelDeFonds',
            component: AppelDeFonds,
            meta: {
              parentName: 'AdvVue',
              requiresAuth: true
            }
          },
          {
            path: 'commercialisation',
            component: CommercialisationFacturation,
            meta: {
              parentName: 'AdvList',
              requiresAuth: true
            },
            props: true,
            children: [
              {
                path: '',
                name: 'Commercialisation',
                component: Commercialisation,
                props: true,
                meta: {
                  parentName: 'AdvList',
                  requiresAuth: true
                }
              },
              {
                path: ':seller_id/facturation',
                name: 'SellerFacturation',
                component: SellerFacturation,
                props: true,
                meta: {
                  parentName: 'Commercialisation',
                  requiresAuth: true
                }
              }
            ]
          }
        ]
      },
      {
        path: 'documents',
        name: 'AdvDocuments',
        component: Documents,
        meta: {
          parentName: 'AdvList',
          requiresAuth: true
        }
      },
      {
        path: 'lot-informations',
        name: 'AdvInfos',
        component: AdvInfos,
        meta: {
          parentName: 'AdvList',
          requiresAuth: true
        }
      },
      {
        path: 'commercialisation',
        component: CommercialisationFacturation,
        meta: {
          parentName: 'AdvList',
          requiresAuth: true
        },
        props: true,
        children: [
          {
            path: '',
            name: 'Commercialisation',
            component: Commercialisation,
            props: true,
            meta: {
              parentName: 'AdvList',
              requiresAuth: true
            }
          },
          {
            path: ':seller_id/facturation',
            name: 'SellerFacturation',
            component: SellerFacturation,
            props: true,
            meta: {
              parentName: 'Commercialisation',
              requiresAuth: true
            }
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/advRouter.js